/**
 * Wrapper around adobe Component clientlibs
 * @type {Object}
 */
export const commonsAdobe = {
  /**
   * init method to trigger running the adobe code
   * @return {void}
   */
  init() {
    // we should always try/catch due to unpredictable clientlibs
    try {
      require('../../../dist/ehi_cheerios/adobe/commons/site/clientlibs/container/js/containerUtils.js');
      require('../../../dist/ehi_cheerios/adobe/commons/site/clientlibs/utils/js/utils.js');
    } catch (e) {
      console.log('[ERROR] Issue loading Adobe Core Common ContainerUtils clientlibs.', e);
    }
  }

};
